module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.1a8799e3.jpeg";